import { gql } from '@lcs/shared/api';

export const getQueueHistoryQuery = gql`
   query GetQueueHistory($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      queueHistoriesConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            queueHistoryId
            queueExtensionId
            queueExtension {
               extensionId
               name
               number
               shortName
            }
            activeCall {
               callDetailId
               serverName
               sipCallId
               callerChannelId
               destinationExtension {
                  extensionId
                  extensionQueue {
                     hasPreventEmptyQueue
                  }
               }
            }
            callDetail {
               callDetailId
               serverName
               sipCallId
               callerChannelId
               destinationExtension {
                  extensionId
                  extensionQueue {
                     hasPreventEmptyQueue
                  }
               }
            }
            agentExtensionNumber
            callerIdName
            callerIdNumber
            callerStatus
            isCallbackRequested
            enqueuedDateTime
            callbackAttempts
            answeredDateTime
            waitTime
            callerStatusDescription
            agentExtensionId
            agentExtension {
               extensionId
               name
               number
            }
         }
      }
   }
`;
